module.exports = __webpack_public_path__ + "img/symbol_10.20485ba8.png";